import { Grid, Typography } from '@mui/material';
import { SarlaftTypificationProps } from './props';
import { useSarlaftTypification } from './hook';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftTypification = (props: SarlaftTypificationProps) => {
    const { formik, typifications, typifications2 } =
        useSarlaftTypification(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Tipificación del caso
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typifications)}
                    label="Tipificación 1"
                    name="typification1"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typification1}
                    errors={formik.errors.typification1}
                    value={formik.values.typification1}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification1', value)
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typifications2)}
                    label="Tipificación 2"
                    name="typification2"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typification2}
                    errors={formik.errors.typification2}
                    value={formik.values.typification2}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification2', value)
                    }
                />
            </Grid>
        </Grid>
    );
};
